import { render } from "./Skeleton.vue?vue&type=template&id=23a1ed2c&scoped=true&ts=true"
import script from "./Skeleton.vue?vue&type=script&lang=ts"
export * from "./Skeleton.vue?vue&type=script&lang=ts"

import "./Skeleton.vue?vue&type=style&index=0&id=23a1ed2c&scoped=true&lang=scss"

import exportComponent from "/builds/rahmet/products/grading-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a1ed2c"]])

export default __exports__